import { render, staticRenderFns } from "./pluginPermissionPopup.vue?vue&type=template&id=651e04f2&scoped=true&"
import script from "./pluginPermissionPopup.vue?vue&type=script&lang=js&"
export * from "./pluginPermissionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e04f2",
  null
  
)

export default component.exports